// src/App.js
import React, { useState, useEffect } from "react";
import {
  BrowserRouter,
  Routes,
  Route,
  useLocation,
  useNavigate,
} from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";

import MyNavbar from "./components/MyNavbar";
import Home from "./pages/Home";
import Chisono from "./pages/Chisono";
import Footer from "./components/Footer";
import Contacts from "./pages/Contacts";
import Coaching from "./pages/Coaching";
import Workouts from "./pages/Workouts";
import RegisterPage from "./pages/RegisterPage";
import Profile from "./pages/Profile";
import LoginModal from "./components/LoginModal";
import Admin from "./pages/Admin";
import WorkoutDetail from "./pages/WorkoutDetail";
import CheckoutSuccess from "./components/CheckoutSuccess";
import CookiePolicy from "./pages/CookiePolicy";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import Terms from "./pages/Terms";


function AppInner() {
  const [showLogin, setShowLogin] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (location.pathname === "/login") {
      setShowLogin(true);
      navigate(-1);
    }
  }, [location.pathname, navigate]);

  return (
    <>
      <MyNavbar onLoginClick={() => setShowLogin(true)} />

      <LoginModal
        show={showLogin}
        handleClose={() => setShowLogin(false)}
        onSuccess={() => {
          setShowLogin(false);
        }}
      />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/workouts/:slug" element={<WorkoutDetail />} />
        <Route path="/chisono" element={<Chisono />} />
        <Route path="/contatti" element={<Contacts />} />
        <Route path="/coaching" element={<Coaching />} />
        <Route path="/workouts" element={<Workouts />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/checkout-success" element={<CheckoutSuccess />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/cookies" element={<CookiePolicy />} />
        <Route path="/terms" element={<Terms />} />

      </Routes>

      <Footer />
    </>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AppInner />
    </BrowserRouter>
  );
}
